// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Select, Option, TextArea } from 'informed';

import {
  addDoctorNote,
  deleteDoctorNote,
  updateDoctorNote,
} from '../../../actions/externalReportsActions';

import DateText from '../../DateText.jsx';
import ValidateText from '../../ValidateText.jsx';
import Table from '../../Table.jsx';
import Typeahead from '../../Typeahead.jsx';
import { Button } from '../../Buttons.jsx';

type Props = {
  doctorNotes: Object[],
  activePatientId: string,
  addDoctorNote: Function,
  deleteDoctorNote: Function,
  updateDoctorNote: Function,
}

class DoctorNotesComponent extends Component<Props> {
  /* eslint-disable no-param-reassign */
  transformDates(formValues) {
    formValues.date = moment(formValues.date, 'DD-MM-YYYY').toISOString();
  }

  handleDeleteRow = (id: string) => {
    this.props.deleteDoctorNote(this.props.activePatientId, id);
  }

  handleSaveRow = (id: string, formData: Object) => {
    this.transformDates(formData.values);
    this.props.updateDoctorNote(this.props.activePatientId, {
      noteId: id,
      ...formData.values,
    });
  }

  handleSaveNewRow = (formData: Object) => {
    this.transformDates(formData.values);
    this.props.addDoctorNote(this.props.activePatientId, formData.values);
  }

  render() {
    const { doctorNotes } = this.props;

    const columns = [
      {
        Header: 'Date',
        id: 'date',
        cell: item => (item.date ? moment(item.date).format() : '--'),
        editCell: item => <DateText field='date' item={item} />,
        width: 100,
      },
      {
        Header: 'Type',
        id: 'type',
        cell: item => (item.type || 'Other'),
        editCell: item => <Select field='type' initialValue={item.type || 'Other'}>
          <Option value='Specialist Appointment'>Specialist Appointment</Option>
          <Option value='Admission Sheet'>Admission Sheet</Option>
          <Option value='Discharge Sheet'>Discharge Sheet</Option>
          <Option value='Surgery'>Surgery</Option>
          <Option value='Invoice'>Invoice</Option>
          <Option value='Referral'>Referral</Option>
          <Option value='Other'>Other</Option>
        </Select>,
      },
      {
        Header: 'Document Name',
        id: 'name',
        editCell: item => <Typeahead field='name' initialValue={item.name} endpoint='docName' />,
      },
      {
        Header: 'Summary',
        id: 'summary',
        editCell: item => <TextArea field='summary' initialValue={item.summary} />,
      },
      {
        Header: 'Doctor\'s Name',
        id: 'doctorName',
        editCell: item => <Typeahead field='doctorName' initialValue={item.doctorName} endpoint='doctorName' />,
      },
      {
        Header: 'Location',
        id: 'location',
        editCell: item => <Typeahead field='location' initialValue={item.location} endpoint='reportLocation' />,
      },
      {
        Header: 'Link',
        id: 'link',
        cell: (item) => {
          if (!item.link) {
            return '--';
          }
          let { link } = item;
          if (link.indexOf('http') === -1) {
            link = `http://${link}`;
          }
          return <a target='_blank' rel='noopener noreferrer' href={link}><Button>Open Link</Button></a>;
        },
        editCell: item => <ValidateText
          field='link'
          initialValue={item.link}
          placeholder='e.g. Google Drive link'
          regex={/^(https?:\/\/.*)?$/}
          errorText='Improper URL, please use http://...'
        />,
        width: 150,
      },
    ];

    return (
      <Table
        columns={columns}
        data={doctorNotes}
        handleDeleteRow={this.handleDeleteRow}
        handleSaveRow={this.handleSaveRow}
        handleSaveNewRow={this.handleSaveNewRow}
      />
    );
  }
}

const mapStateToProps = state => ({
  doctorNotes: state.patient.data.externalReports.doctorNotes,
  activePatientId: state.patient.data.activePatientId,
});

const mapDispatchToProps = dispatch => ({
  addDoctorNote:
    (patientId, doctorNote) => dispatch(addDoctorNote(patientId, doctorNote)),
  deleteDoctorNote:
    (patientId, doctorNoteId) => dispatch(deleteDoctorNote(patientId, doctorNoteId)),
  updateDoctorNote:
    (patientId, doctorNote) => dispatch(updateDoctorNote(patientId, doctorNote)),
});

const DoctorNotes = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DoctorNotesComponent);

export default DoctorNotes;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/externalReports/DoctorNotes.jsx